<ng-container *ngIf="onMobileView === true">
  <div class="states mobile mb-md-2">
    <span class="heading">Bundesland wählen</span>
    <div class="boxes-mobile" [class.equally-distributed]="states.length >= 5">
      <div *ngFor="let state of states; let first = first" class="slide">
        <app-search-cell [state]="state" [class.ml-0]="first"
                         (click)="onStateClick(state)" [smallMargin]="true"></app-search-cell>
      </div>
    </div>
  </div>
</ng-container>
